import styled from '@emotion/styled';
import Image from 'next/image';
import { Modal } from '@mui/material';
import { shouldForwardProps } from '../../utils';
import { BodyMedium, Column, Row } from '../../styles';
import { TextButton } from '..';
import ReactPlayer from 'react-player/lazy';

const ModalContainer = styled(Modal, shouldForwardProps)`
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: ${({ theme }) => theme.zIndex.modal};
    inset: 0;
`;
const ModalContent = styled(Row)`
    width: 95vw;
    height: 70vh;
    // prevent focus-outline
    :focus-visible {
        outline: none;
    }

    @media (min-width: 768px) {
        width: 85vw;
        height: 75vh;
    }

    @media (min-width: 1024px) {
        width: 80vw;
        height: 80vh;
    }
`;

const GalleryContent = styled(Column)`
    position: relative;
    max-height: 100%;
    max-width: 100%;
`;

const GalleryImage = styled(Image, shouldForwardProps)<{ hasInfo: boolean }>`
    object-fit: contain;
    border-radius: 28px;
    border-bottom-left-radius: ${({ hasInfo }) => (hasInfo ? 0 : '28px')};
    border-bottom-right-radius: ${({ hasInfo }) => (hasInfo ? 0 : '28px')};
    transition:
        width 0.1s,
        height 0.1s;
`;

const GalleryVideo = styled(ReactPlayer)`
    border-top-left-radius: 28px;
    border-top-right-radius: 28px;
    background-color: ${({ theme }) => theme.colors.surface};
    .react-player__preview,
    iframe {
        border-top-left-radius: 28px;
        border-top-right-radius: 28px;
    }
`;

const InfoTextContainer = styled(Column)`
    position: absolute;
    width: 100%;
    gap: ${({ theme }) => theme.spacing(2)};
    padding: ${({ theme }) => theme.spacing(3)};
    border-bottom-left-radius: 28px;
    border-bottom-right-radius: 28px;
    background-color: ${({ theme }) => theme.colors.surface};
`;

const Source = styled(Row)`
    gap: ${({ theme }) => theme.spacing(1)};
    color: ${({ theme }) => theme.colors.disabledText};
`;

const SourceText = styled(BodyMedium)`
    font-size: inherit;
    overflow: hidden;
    position: relative;
    display: inline-block;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
`;

const SourceTextButton = styled(TextButton, shouldForwardProps)`
    width: fit-content;
    max-width: 100%;
    p {
        display: inline-block;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 100%;
    }
`;

export {
    ModalContainer,
    ModalContent,
    GalleryContent,
    GalleryImage,
    GalleryVideo,
    InfoTextContainer,
    Source,
    SourceText,
    SourceTextButton
};
